import type { ReactNode } from 'react';
import { CopyButton } from '@pryme/ui';

export function CodeBlock(props: { code: string; label?: string; copy?: boolean; maxHeight?: number }) {
  return (
    <figure style={{ margin: '0 0 1rem' }}>
      {(props.label || props.copy !== false) && (
        <figcaption className="dv-code-head">
          <span className="dv-code-label">{props.label}</span>
          {props.copy !== false && <CopyButton value={props.code} label={props.label ? `Copy ${props.label.toLowerCase()}` : 'Copy'} />}
        </figcaption>
      )}
      <pre className="p-code" tabIndex={0} style={props.maxHeight ? { maxHeight: props.maxHeight, overflowY: 'auto' } : undefined}>
        {props.code}
      </pre>
    </figure>
  );
}

/** A labelled monospace value with a copy button and, optionally, the environment variable it belongs in. */
export function CopyField(props: { label: string; value: string; hint?: ReactNode; envVar?: string; tag?: ReactNode }) {
  return (
    <div className="dv-copy">
      <div className="p-row p-between" style={{ gap: '0.5rem' }}>
        <span className="dv-copy-label">
          {props.label}
          {props.tag}
        </span>
        {props.envVar && <span className="dv-envvar">{props.envVar}</span>}
      </div>
      <div className="dv-copy-row">
        <code>{props.value}</code>
        <CopyButton value={props.value} label="Copy" />
      </div>
      {props.hint && <span className="p-hint">{props.hint}</span>}
    </div>
  );
}
